import React, { useEffect, useState } from 'react';
import '../Styles/FoodCards.css';
import {getProducts} from '../Helpers/getProducts'
import price from '../Icons/price1.png';
import {appendToStorage} from '../Helpers/appendToStorage';
import { getNumProds } from '../Helpers/getNumProds';
import { simpleAction } from '../Redux/actions/simpleAction';
import { useDispatch, useSelector } from 'react-redux';
import { store } from 'react-notifications-component';
import "react-notifications-component/dist/theme.css";
import "animate.css";
import {searchMatcher} from '../Helpers/searchMatcher';

const FoodCard = props => {

    const handleNotification = (texto) =>{
        store.addNotification({
            title: "Producto añadido",
            message: texto,
            type: "success",
            container: "top-center",
            insert: "top",
            animationIn:["animated", "fadeIn"],
            animationOut:["animated", "fadeOut"],

            dismiss:{
                duration:2000,
                showIcon: true
            }
        })
    }

    const [ products, setProducts ] = useState([]);
    const [ description, setDescription ] = useState(0);
    const [ carrazo, setCarrazo ] = useState([])

    const dispatch = useDispatch();
    const CatToggler = useSelector(state=>state.categoriesToggler)
    const numbersDucer = useSelector(state=>state.numbersDucer)

    useEffect(()=>{
        getProducts(products, setProducts);
        let carrito = window.localStorage.getItem('carrito')
    }, [])

    return(
        <section className="products">
            {/* <div className="Card-container">
                <div className="title-card">
                    <p>Empanada de carne</p>
                </div>
                <div className="Container">
                    <div className="Img-container">
                        <img src={empanada1}></img>
                        <div className="price">
                            <img id="price" src={price}></img>
                            <p>hi</p>     
                        </div>                
                    </div>
                </div>
                <footer className="footer-card">
                    <div className="Link-ingredients">
                        <a className="Linki">
                            <img src="Img/grocery.png"></img>
                        </a>
                        <p className="Link-name">Ingredientes</p>
                    </div>

                    <div className="Link-add">
                        <a className="Linki">
                            <img src="Img/add.png"></img>
                        </a>
                        <p className="Link-name">Añadir</p>
                    </div>

                    <div className="Link-descrip">
                        <a className="Linki">
                            <img src="Img/info.png"></img>
                        </a>
                        <p className="Link-name">Descripcion</p>
                    </div>
                </footer>
            </div>

            <div className="Card-container">
                <div className="title-card">
                    <p>Empanada de atún</p>
                </div>
                <div className="Container">
                    <div className="Img-container">
                        <img src={empanada2}></img>
                    </div>
                </div>
                <footer className="footer-card">
                    <div className="Link-ingredients">
                        <a className="Linki">
                            <img src="Img/grocery.png"></img>
                        </a>
                        <p className="Link-name">Ingredientes</p>
                    </div>

                    <div className="Link-add">
                        <a className="Linki">
                            <img src="Img/add.png"></img>
                        </a>
                        <p className="Link-name">Añadir</p>
                    </div>

                    <div className="Link-descrip">
                        <a className="Linki">
                            <img src="Img/info.png"></img>
                        </a>
                        <p className="Link-name">Descripcion</p>
                    </div>
                </footer>
            </div>
 */}
            {
                products.map( prod => {
                    if (CatToggler.todo){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE);}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                else if (CatToggler.burritos){
                    if (prod.CATEGORIA === "BURRITOS"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.tacos){
                    if (prod.CATEGORIA === "ENTRANTES"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.bebidas){
                    if (prod.CATEGORIA === "BEBIDAS"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.postres){
                    if (prod.CATEGORIA === "POSTRES"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.arroz){
                    if (prod.CATEGORIA === "PRINCIPALES"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.suplementos){
                    if (prod.CATEGORIA === "SUPLEMENTOS"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.pasta){
                    if (prod.CATEGORIA === "PASTAS"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.quesadillas){
                    if (prod.CATEGORIA === "VEGANOS"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.search){
                    if (searchMatcher(prod.NOMBRE, numbersDucer.searchname)){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.enchiladas){
                    if (searchMatcher(prod.NOMBRE, "enchilada")){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.croquetas){
                    if (searchMatcher(prod.NOMBRE, "croqueta")){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.nachos){
                    if (searchMatcher(prod.NOMBRE, "nacho")){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                else if (CatToggler.empanadas){
                    if (searchMatcher(prod.NOMBRE, "empanada") && prod.NOMBRE !== "Pechuga Empanada de Pollo con Pure de Patatas"){
                        return(
                            <div className="Card-container">
                    <div className="title-card">
                        <p>{prod.NOMBRE}</p>
                    </div>
                    <div className="Container">
                        <div className="Img-container">
                            <img src={"/productos/"+prod.IMAGEN}></img>
                            <div className="price">
                                <img id="price" src={price}></img>
                        <p>{prod.PRECIO} €</p>     
                            </div>
                            <div className={
                                description === prod.ID
                                ? "description"
                                : "hiddendes"
                            }>
                                <div className="miniHeader">
                                    <p>Descripcion</p>
                                    <button type="button"
                                    onClick={()=>{setDescription(0)}}>X</button>
                                </div>
                                <div className="miniBody">
                                    <p>{prod.DESCRIPCION}</p>
                                </div>
                            </div>             
                        </div>
                    </div>
                    <footer className="footer-card">
                        <div className="Link-ingredients">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/grocery.png"></img>
                            </a>
                            <p className="Link-name">Ingredientes</p>
                        </div>
    
                        <div className="Link-add">
                            <a className="Linki" onClick={()=>{appendToStorage('carrito', JSON.stringify(prod));
                        setCarrazo([localStorage.getItem("carrito")]);
                        getNumProds(dispatch, simpleAction); handleNotification(prod.NOMBRE)}}>
                                <img src="Img/add.png"></img>
                            </a>
                            <p className="Link-name">Añadir</p>
                        </div>
    
                        <div className="Link-descrip">
                            <a className="Linki" onClick={()=>{setDescription(prod.ID)}}>
                                <img src="Img/info.png"></img>
                            </a>
                            <p className="Link-name">Descripcion</p>
                        </div>
                    </footer>
                </div>
                        )
                    }
                }
                })
            }

            
        </section>
    )
}
export default FoodCard;